import React, { useState } from 'react';
import axios from 'axios';
import styles from './Register.module.scss'; // Assuming you are using SASS for styling
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

const Register = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    role: '',
    permissions: '',
  });

  const [message, setMessage] = useState('');

  const { username, email, password, role, permissions } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL}/auth/register`, {
        username,
        email,
        password,
        role,
        permissions: permissions.split(',').map((perm) => perm.trim()),
      });
      setMessage('Registration successful!');
      console.log(res.data); // Handle successful registration
    } catch (err) {
      console.error(err);
      setMessage('Registration failed.');
    }
  };

  return (
    <>
    <div className='bg_login'>
      <Container>
        <Row className="justify-content-center" style={{minHeight:'100vh'}}>
          <Col xs="12" lg="7" className='text-center align-self-center lft_bx'>
            <h1>What is Lorem Ipsum?</h1>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
          </Col>
          <Col xs="12" lg="5" className='align-self-center'>
            <div className='lg_bx lg_bx_si'>
            <h2 className='text-start mb-3'>Why do we use it?</h2>
            {message && <p>{message}</p>}
            <form onSubmit={onSubmit}>
              <input
                type="text"
                name="username"
                value={username}
                onChange={onChange}
                placeholder="Username"
                required
              />
              <input
                type="email"
                name="email"
                value={email}
                onChange={onChange}
                placeholder="Email"
                required
              />
              <input
                type="password"
                name="password"
                value={password}
                onChange={onChange}
                placeholder="Password"
                required
              />
              <input
                type="text"
                name="role"
                value={role}
                onChange={onChange}
                placeholder="Role"
                required
              />
              <input
                type="text"
                name="permissions"
                value={permissions}
                onChange={onChange}
                placeholder="Permissions (comma separated)"
              />
              <button type="submit">Register</button>
            </form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
    </>

  );
};

export default Register;
